import { treatImage } from '../../../server/utils/images';

const config = {
  dataUrl: '/node/home/api/recent-activity/fullV1',
  options: {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }
};

const replaceImageUrl = img => treatImage(img, 'c9').replace('.c10.', '.c9.');

const DEFAULT_SCRATCHPAD = {
  summaries: [],
  messagesSummary: {},
  footerSummary: {},
  totalResults: 0
};

const getSearchObject = ({
  lbsUuid = '',
  arrivalDate = '',
  departureDate = '',
  searchTerm = '',
  searchTime = '',
  continueSearchSummary = {},
  seeMoreLikeThis = {}
}, site) => ({
  arrivalDate,
  continueSearchSummary: {
    ...continueSearchSummary,
    href: site !== 'vrbo' ? seeMoreLikeThis.href : continueSearchSummary.href
  },
  departureDate,
  searchTerm,
  searchTime,
  lbsUuid,
  isSearch: true
});

const getPropertyList = properties => properties.map(({
  hit,
  presentation,
  addedTime
}) => ({
  ...hit,
  ...presentation,
  imageUrl: replaceImageUrl(hit.thumbnailUrl1),
  addedTime
}));

/*
  NOTE: this happens when a searhSummary has not properties.
  In this case, we don't want the search card to appear.
*/
const createActivityList = (listings, site) =>
  listings.reduce((acc, { propertiesSummary = {}, ...item }) =>
    propertiesSummary.properties && propertiesSummary.properties.length > 0 ?
      [
        ...acc,
        { ...getSearchObject(item, site) },
        ...getPropertyList(propertiesSummary.properties)
      ] : acc
    , []);

const composeScratchpad = site => (data = DEFAULT_SCRATCHPAD) => {
  const {
    summaries,
    messagesSummary,
    footerSummary,
    totalResults
  } = data;

  return {
    title: messagesSummary.scratchpadActivity,
    viewInScratchpad: footerSummary.headline,
    data: totalResults > 0 ? createActivityList(summaries, site) : summaries
  };
};

const getScratchpad = ({ site }) =>
  fetch(config.dataUrl, config.options)
    .then(response => response.json())
    .then(composeScratchpad(site))
    .catch(() => DEFAULT_SCRATCHPAD);

export { getScratchpad };
